import { API_REFERENCE } from '../utilities/constant_api';
import { showPassword, hidePassword } from '../utilities/utility';
import { formPostJsonResponse, htmlPost } from '../components/ajax';
$(function() {
  var monthtext = [
    '',
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];
  let preRegValidateStepOneAjaxReq = true;
  let preRegSaveFacilityAjaxReq = true;

  function populatedropdown(day, month, year) {
    var today = new Date();
    var dayfield = document.getElementById(day);
    var monthfield = document.getElementById(month);
    var yearfield = document.getElementById(year);
    for (var i = 1; i <= 31; i += 1) {
      dayfield.options[i] = new Option(i, i + 1);
    }
    for (var m = 1; m <= 12; m += 1) {
      monthfield.options[m] = new Option(monthtext[m], monthtext[m]);
    }
    var thisyear = today.getFullYear() - 125;
    for (var y = 1; y <= 126; y += 1) {
      yearfield.options[y] = new Option(thisyear, thisyear);
      thisyear += 1;
    }
  }

  function validateDate() {
    var ddlDay = $('#daydropdown');
    var ddlMonth = $('#monthdropdown');
    var ddlYear = $('#yeardropdown');

    var date = new Date();
    var month = 0;
    switch (ddlMonth.val()) {
      case 'January':
        month = 1;
        break;
      case 'February':
        month = 2;
        break;
      case 'March':
        month = 3;
        break;
      case 'April':
        month = 4;
        break;
      case 'May':
        month = 5;
        break;
      case 'June':
        month = 6;
        break;
      case 'July':
        month = 7;
        break;
      case 'August':
        month = 8;
        break;
      case 'September':
        month = 9;
        break;
      case 'October':
        month = 10;
        break;
      case 'November':
        month = 11;
        break;
      case 'December':
        month = 12;
        break;
      default:
        month = 0;
    }
    var inputDate = ''
      .concat(ddlYear.val(), '-')
      .concat(month, '-')
      .concat(ddlDay.val() - 1);
    var parsedDate = ''
      .concat(date.getFullYear(), '-')
      .concat(date.getMonth() + 1, '-')
      .concat(date.getDate());
    var date1 = new Date(inputDate);
    var date2 = new Date(parsedDate);
    if (date1 > date2) {
      $('.error-invalidDate').attr('hidden', false);
      $('.dateDrop').addClass('error-msg-textbox');
      return false;
    }
    return true;
  }

  function validatePreDate() {
    var ddlDay = $('.daySelect');
    var ddlMonth = $('.monthSelect');
    var ddlYear = $('.yearSelect');
    var date = new Date();

    var inputDate = ''
      .concat(ddlYear.val(), '-')
      .concat(parseInt(ddlMonth.val()), '-')
      .concat(ddlDay.val());
    var parsedDate = ''
      .concat(date.getFullYear(), '-')
      .concat(date.getMonth() + 1, '-')
      .concat(date.getDate());
    var date1 = new Date(inputDate);

    var date2 = new Date(parsedDate);

    if (date1 > date) {
      $('.error-invalidDate').attr('hidden', false);
      $('.dateDrop').addClass('error-msg-textbox');
      return false;
    }

    $('.error-invalidDate').attr('hidden', true);
    $('.dateDrop').removeClass('error-msg-textbox');
    $('.error-msg-text-date').attr('hidden', true);
    return true;
  }

  function validateLastNamePre() {
    var name = /^[a-zA-Z0-9\s'-]+$/;
    var inputName = $('.register_firstnameInput.lastname').val();
    if ($('.register_firstnameInput.lastname').val() === '') {
      $('.error-msg-text-lastname').attr('hidden', false);
      $('.error-msg-text-invalidName').attr('hidden', true);
      $('.register_firstnameInput.lastname').addClass('error-msg-textbox');
    }
    if (!name.test(inputName) && inputName !== '') {
      $('.error-msg-text-lastname').attr('hidden', true);
      $('.error-msg-text-invalidName').attr('hidden', false);
      $('.register_firstnameInput.lastname').addClass('error-msg-textbox');
    } else {
      $('.error-msg-text-lastname').attr('hidden', true);
      $('.error-msg-text-invalidName').attr('hidden', true);
      $('.register_firstnameInput.lastname').removeClass('error-msg-textbox');
    }
    return true;
  }

  function inValidInput(e) {
    if (!e.target.validity.valid) {
      e.preventDefault();
      $(this)
        .next()
        .attr('hidden', false);
      $(this).addClass('error-msg-textbox');
    }
  }

  function inValidInputPassword(e) {
    if (!e.target.validity.valid) {
      e.preventDefault();
      if ($(this).val() === '') {
        $(this)
          .next()
          .next()
          .attr('hidden', false);
        $(this).addClass('error-msg-textbox');
      } else {
        $(this)
          .next()
          .next()
          .next()
          .attr('hidden', false);
        $(this).addClass('error-msg-textbox');
      }
    }
  }

  function validateInput(e) {
    e.preventDefault();
    $('.error-securityAnswer').attr('hidden', true);
    $('.error-msg-password').attr('hidden', true);
    $(this)
      .next()
      .attr('hidden', true);
    $(this).removeClass('error-msg-textbox');
    $('.dateDrop').removeClass('error-msg-textbox');
    $('.error-invalidDate').attr('hidden', true);
    if ($(this).val() === '') {
      e.preventDefault();
      $(this)
        .next()
        .attr('hidden', false);
      $(this).addClass('error-msg-textbox');
    }
  }

  function validateInputPassword(e) {
    const pwdField = $(this).hasClass('passwordFieldValidation');
    e.preventDefault();
    $(this)
      .siblings('.error-msg-text')
      .attr('hidden', true);
    $(this).removeClass('error-msg-textbox');
    $('.dateDrop').removeClass('error-msg-textbox');
    if (pwdField) {
      confirmPasswordValidation();
    }
    if ($(this).val() === '') {
      e.preventDefault();
      $(this)
        .siblings('.value-missing-text')
        .attr('hidden', false);
      $(this).addClass('error-msg-textbox');
    }
  }

  function confirmPasswordValidation() {
    $('.showhide-field').attr('hidden', false);
    var password = $('.passwordField').val();
    var confirmPassword = $('.confirmPasswordField').val();
    var confirmPwdField = $('.confirmPasswordField');

    if (password.length || confirmPassword.length) {
      $(confirmPwdField).removeClass('error-msg-textbox');
      $(confirmPwdField)
        .siblings('.error-msg-text')
        .attr('hidden', true);
      if (password !== confirmPassword && confirmPassword.length > 0) {
        $('.confirmPasswordField').addClass('error-msg-textbox');
        $('#confirmCreateNewPassword').addClass('error-msg-textbox');
        $('#confirmCreateNewPassword').removeClass('success-msg-textbox');
        $('.error-msg-password-noMatch').attr('hidden', false);
        return false;
      }
      if(confirmPassword.length == 0){
        $('#confirmCreateNewPassword').removeClass('success-msg-textbox');
      }
      if (password === confirmPassword) {
        $('#confirmCreateNewPassword').addClass('success-msg-textbox');
        $('.error-msg-password-noMatch').attr('hidden', true);
      }
    }
    return true;
  }

  function validateStep11(e) {
    e.preventDefault();
    if (!validateDate()) {
      return false;
    }
    if (!validateLastNamePre()) {
      return false;
    }
    if (e.target.checkValidity.length === 0) {
      $('.step_1_div').attr('hidden', true);
      $('.step_2_div').attr('hidden', false);
    }
    return true;
  }

  function validateStep1(e) {
    e.preventDefault();

    if (!validatePreDate() || !validateLastNamePre()) {
      return false;
    }

    var submitLeadUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.preregister.validatePreregistrationStep1}`;
    var currentForm = $('.step1_form').serialize();
    var termsAndConditionData = null;
    if (!preRegValidateStepOneAjaxReq) return false;
    preRegValidateStepOneAjaxReq = false;
    formPostJsonResponse(submitLeadUrl, currentForm)
      .then(data => {
        preRegValidateStepOneAjaxReq = true;
        if (data !== 'FAIL') {
          $('.dob-msg-required').attr('hidden', true);
          $('.prereg').hide();
          $('.preRegistration_step2').removeClass('hidden');
          $('.preRegistration_step2').show('fast', function() {
            $(window).scrollTop(0);

            $('#referral_div').remove();
          });
        } else {
          $('.noRecordDiv').attr('hidden', false);
        }
      })
      .catch(() => {
        preRegValidateStepOneAjaxReq = true;
      });
  }

  function validateStep2(e) {
    e.preventDefault();
    if (!confirmPasswordValidation()) {
      return false;
    }
    return true;
  }

  function togglePwdView() {
    const requiredSelector = $(this)
      .parent()
      .siblings('.passwordFieldValidation');
    const passwordType = requiredSelector.attr('type');
    if (passwordType === 'text') {
      hidePassword(requiredSelector);
    } else {
      showPassword(requiredSelector);
    }
  }

  var elements1 = document.getElementsByClassName('step1_input');
  $.each(elements1, function(i, inputVal) {
    inputVal.addEventListener('invalid', inValidInput);
  });

  var elementsStep2 = document.getElementsByClassName('registerStep2_input');
  $.each(elementsStep2, function(i, inputVal) {
    inputVal.addEventListener('invalid', inValidInput);
  });

  var elementsPassword = document.getElementsByClassName(
    'passwordFieldValidation'
  );
  $.each(elementsPassword, function(i, inputVal) {
    inputVal.addEventListener('invalid', inValidInputPassword);
  });

  function addNewFacilityModalPopup() {
    $('.addNewFacilityModalSection').show();
    cancelState();
    ACC.colorbox.open('', {
      inline: true,
      href: '#addNewFacilityModal',
      className: 'signin-colorbox-dialog',
      onClosed: function() {
        $('.addNewFacilityModalSection').hide();
      }
    });
  }

  function backToPreRegistrationStep1() {
    $('.prereg').show();
    $('.preRegistration_step2').hide();
  }

  var elements = $('.custom-input-valid');
  $.each(elements, function(i, inputVal) {
    inputVal.addEventListener('invalid', inValidInput);
  });

  function inValidInput(e) {
    e.preventDefault();
    if (!e.target.validity.valid) {
      if ($(this).is('select')) {
        $(this)
          .parent()
          .find('.error-msg-text')
          .attr('hidden', false);
        $(this)
          .parent()
          .find('.ui-selectmenu-button')
          .addClass('error-msg-textbox');
      } else {
        const enteredPassword = '';

        if ($(this).hasClass('passwordField')) {
          enteredPassword = $(this).val();
          if (enteredPassword === '') {
            $(this)
              .parent()
              .find('.error-msg-text-password')
              .attr('hidden', false);
            $(this).addClass('error-msg-textbox');
          } else {
            if (e.target.validity.patternMismatch) {
              $(this)
                .parent()
                .find('.pattern-mismatch-text')
                .attr('hidden', false);
              $(this).addClass('error-msg-textbox');
            }
          }
        } else if ($(this).hasClass('confirmPasswordField')) {
          if ($(this).val() === '') {
            $(this)
              .parent()
              .find('.error-msg-text-password')
              .attr('hidden', false);
            $(this).addClass('error-msg-textbox');
          } else if (e.target.validity.patternMismatch) {
            $(this)
              .parent()
              .find('.pattern-mismatch-text')
              .attr('hidden', false);
            $(this)
              .parent()
              .find('.error-msg-password-noMatch')
              .attr('hidden', true);
            $(this).addClass('error-msg-textbox');
          } else if ($(this).val() !== enteredPassword) {
            $(this)
              .parent()
              .find('.error-msg-password-noMatch')
              .attr('hidden', false);
            $(this).addClass('error-msg-textbox');
          }
        }
        if (
          $(this).hasClass('new-address-zip-value') &&
          $(this)
            .val()
            .trim() === '' &&
          $(this).parents('.checkout-add-edit-address__form').length > 0
        ) {
          $(this)
            .parent()
            .find('.invalid-zip-code-paste')
            .attr('hidden', true);
        }
      }
      if (
        $(this).hasClass('new-address-zip-value') &&
        $(this)
          .val()
          .trim() !== '' &&
        $(this).parents('.checkout-add-edit-address__form').length > 0
      ) {
        $(this)
          .next()
          .attr('hidden', true);
      }
    }
  }

  function cancelState() {
    const facilityStateDropdown = $('#facilityState');
    const facilityPhoneNumber = $('#fpNumber');
    // eslint-disable-next-line spaced-comment
    $('.accountFacilitiesForm').trigger('reset');
    $('.custom-input-valid')
      .next()
      .attr('hidden', true);
    $('.custom-input-valid').removeClass('error-msg-textbox');
    facilityPhoneNumber
      .parent()
      .find('.error-msg-text')
      .attr('hidden', true);
    facilityPhoneNumber.removeClass('error-msg-textbox');
    facilityStateDropdown
      .parent()
      .find('.error-msg-text')
      .attr('hidden', true);
    facilityStateDropdown.next().removeClass('error-msg-textbox');
    $('#cboxClose').click();
  }

  function closeModal() {
    ACC.colorbox.close();
  }

  function onSubmitFacilityPhoneCheck(targetEle) {
    const targetEleParent = targetEle.parent();
    if (
      targetEleParent.find('.value-missing-text').is(':hidden') &&
      targetEleParent.find('.pattern-mismatch-text').is(':hidden')
    ) {
      return true;
    } else {
      return false;
    }
  }

  function saveNewFacility() {
    if (
      $('#facilityName').val() !== '' &&
      $('#fpnumber').val() !== '' &&
      onSubmitFacilityPhoneCheck($('#fpNumber')) &&
      $('#facilityState').val() !== ''
    ) {
      if (!preRegSaveFacilityAjaxReq) return false;
      preRegSaveFacilityAjaxReq = false;
      const submitUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.facilitySearch.saveNewFacility}`;
      const facilityData = $('#accountFacilitiesForm').serialize();
      htmlPost(submitUrl, facilityData)
        .then(data => {
          preRegSaveFacilityAjaxReq = true;
          closeModal();
          $('.select-facility')
            .show()
            .html(data);
          $('.search-result-phonenumber').text(function(i, text) {
            text = text.replace(/(\d{3})(\d{3})(\d{4})/, '$1.$2.$3');
            return text;
          });
        })
        .catch(() => {
          preRegSaveFacilityAjaxReq = true;
        });
    } else {
      if (
        $('#fpNumber').val() === '' &&
        $('#fpNumber')
          .parent()
          .find('.value-missing-text')
          .is(':hidden')
      ) {
        $('#fpNumber')
          .addClass('error-msg-textbox')
          .parent()
          .find('.value-missing-text')
          .attr('hidden', false);
      }
      $('.accountFacilitiesForm .custom-input-valid').each(function() {
        if ($(this).val() == '' || $(this).val() == null) {
          if ($(this).is('select')) {
            $(this)
              .parent()
              .find('.ui-selectmenu-button')
              .addClass('error-msg-textbox');
            $(this)
              .parent()
              .find('.error-msg-text')
              .attr('hidden', false);
          } else {
            $(this)
              .addClass('error-msg-textbox')
              .parent()
              .find('.error-msg-text')
              .attr('hidden', false);
          }
        }
      });
      return false;
    }
  }
  function checkIfPreregisterLinkExpired() {
    const linkExpiryVal = $('#preregister-link-expiry');
    if (linkExpiryVal.length > 0 && linkExpiryVal.val() === 'true') {
      $('.global-error-message-container').addClass('hidden');
      $('.token-expiry-msg-section').removeClass('hidden');
    }
  }

  checkIfPreregisterLinkExpired();

  $('.register_firstnameInput.lastname').on('input', validateLastNamePre);
  $('.step1_input').on('input', validateInput);
  $('.dateDrop').on('input', validateInput);
  $('.step1_form').on('submit', validateStep1);
  $('.step2_form').on('submit', validateStep2);
  $('.registerStep2_input').on('input', validateInputPassword);
  $('.show-create-password,.hide-create-password').on('click', togglePwdView);
  $('.preRegistration_step2 .bck').on('click', backToPreRegistrationStep1);
  $(document).on('click', '#add-new-facility-modal', addNewFacilityModalPopup);
  $('.cancel').on('click', cancelState);
  $(document).on('click', '#saveNewFacility', saveNewFacility);
  $(document).on('blur',"#createNewPassword",passwordValidationForInstruction);
  var patternMatchCount = 0;

      function passwordValidationForInstruction(){

      const createNewPasswordValue = $("#createNewPassword").val();
      const passwordMessageItems = document.getElementsByClassName("password-message-item")
      
            patternCheck(passwordMessageItems[1],/[0-9]/g,createNewPasswordValue);
            patternCheck(passwordMessageItems[2],/[A-Z]/g,createNewPasswordValue);
            patternCheck(passwordMessageItems[3],/[a-z]/g,createNewPasswordValue);
            patternCheck(passwordMessageItems[4],/[!#$%&’*+,-.:;<=>?@^_`\)~\(\[\]\{\}\|\\\/\""'']/,createNewPasswordValue);

           // Checking length of the password
          if (createNewPasswordValue.length >= 8 && createNewPasswordValue.length <= 25) {
              passwordMessageItems[0].classList.remove("invalid");
              passwordMessageItems[0].classList.add("valid");
              
          } else {
              passwordMessageItems[0].classList.remove("valid");
              passwordMessageItems[0].classList.add("invalid");
              $(".password-message").removeClass("d-none");
          }
          if (patternMatchCount == 4 && (createNewPasswordValue.length >= 8 && createNewPasswordValue.length <= 25)){
            $("#createNewPassword").addClass("success-msg-textbox");
            $("#createNewPassword").removeClass("error-msg-textbox");
          }else{
            $("#createNewPassword").removeClass("success-msg-textbox");
              $("#createNewPassword").addClass("error-msg-textbox");
          }
          patternMatchCount = 0;
        }

        function patternCheck(passwordMessageItem,regexPattern,createNewPasswordValue){
          if (createNewPasswordValue.match(regexPattern)) {
              passwordMessageItem.classList.remove("invalid")
              passwordMessageItem.classList.add("valid")
              patternMatchCount = patternMatchCount+1;
          } else {
              passwordMessageItem.classList.remove("valid");
              passwordMessageItem.classList.add("invalid");
              $(".password-message").removeClass("d-none");
          }
        }
});